import { storyblokInit, apiPlugin } from "@storyblok/js";
class StoryblokService {
  constructor() {
    this.storyblokApi = void 0;
    this.baseURL = void 0;
    const {
      storyblokApi
    } = storyblokInit({
      accessToken: process.env.NEXT_PUBLIC_STORYBLOK_TOKEN,
      use: [apiPlugin]
    });
    this.storyblokApi = storyblokApi;
    this.baseURL = 'muscle_storefront';
  }
  async getStoryblokData(slug) {
    try {
      let language = 'es';
      if (typeof window !== 'undefined') {
        language = localStorage.getItem('locale') || 'es';
      }
      const {
        data
      } = await this.storyblokApi.get("cdn/stories/".concat(slug), {
        language: language
      });
      return data.story.content.body;
    } catch (error) {
      console.warn("Error fetching story: ".concat(slug), error);
      return null;
    }
  }
  async getStoryblokDataServer(slug) {
    try {
      const data = await this.getStoryblokData(slug);
      return data;
    } catch (error) {
      console.warn("Error fetching story: ".concat(slug), error);
      return null;
    }
  }
  async getSingleImage(slug) {
    try {
      const data = await this.getStoryblokData(slug);
      if (!data) {
        return "";
      }
      return data[0].src.url;
    } catch (error) {
      console.warn("Error fetching image: ".concat(slug), error);
      return "";
    }
  }
  async getSinglePdf(slug) {
    const data = await this.getStoryblokData(slug);
    if (!data || !data[0] || !data[0].asset) {
      return "";
    }
    return data[0].asset.filename;
  }
  async getSinglePdfServer(slug) {
    try {
      const data = await this.getStoryblokDataServer(slug);
      if (!data || !data[0] || !data[0].asset) {
        return "";
      }
      return data[0].asset.filename || data[0].asset;
    } catch (error) {
      console.warn("Error fetching PDF: ".concat(slug), error);
      return "";
    }
  }
}
export default StoryblokService;